<!--
 * @Author: 鸦雀銮翎
 * @Date: 2023-05-10 11:33:13
 * @LastEditTime: 2024-02-29 16:13:59
 * @Description:
 * @FilePath: \website\src\pages\news\content.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
    <div>
        <img width="100%" src="http://wwwadm.tudouec.com/profile/resource/www_img/banner-news.png" alt="" />
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item
                v-if="pageData.newsType == 'report'"
                :to="{ name: 'quotation' }"
                >薯价行情</el-breadcrumb-item
            >
            <el-breadcrumb-item v-else :to="{ name: 'news' }"
                >政策资讯</el-breadcrumb-item
            >
            <el-breadcrumb-item>{{ pageData.title }}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="text-block">
            <div class="content" v-html="pageData.content"></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    computed: {
        pageData() {
            return this.$route.params;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/public.scss";
.el-breadcrumb,
.text-block {
    @extend .topic;
    margin-top: 20px;
}
.content {
    background-color: #fff;
    padding: 56px 72px;
    margin-bottom: 105px;
}
</style>



// WEBPACK FOOTER //
// src/pages/news/content.vue